import { TDatabaseId } from '@infotech-soe/metaschema';

import { CategoryTreeNode } from '../../../store/slices/dm-trees/CategoryTreeNode';

export const findNode = (
  nodes: CategoryTreeNode[],
  nodeId: TDatabaseId | null
): CategoryTreeNode | undefined =>
  nodes.find(node => String(node.id) === String(nodeId));
